import React from "react";

const SettlementSummary = ({ earnings }) => {

    const completed = earnings.filter(
        e => e.settlementStatus === "Completed"
    ).length;

    const processing = earnings.filter(
        e => e.settlementStatus === "Processing"
    ).length;

    const pending = earnings.filter(
        e => e.settlementStatus === "Pending"
    ).length;

    return (

        <div className="settlement-summary">

            <h3>Settlement Summary</h3>

            <p>Completed : {completed}</p>

            <p>Processing : {processing}</p>

            <p>Pending : {pending}</p>

        </div>

    );

};

export default SettlementSummary;